module.exports = __webpack_public_path__ + "img/807068_C3B0AB_443E3B_AC9C94-256px.89ec6779.png";